export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";
export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
export const MEMBER_UPDATED = "MEMBER_UPDATED";
export const IS_OPEN_LOGIN_FORM = "IS_OPEN_LOGIN_FORM";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_COMMENTS_TOKEN = "UPDATE_COMMENTS_TOKEN";
export const ISLOGIN = "ISLOGIN";

// Action to enable/disable to loading indicator
export function setLoading(isLoading) {
  return isLoading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" };
}

export const setMoreStories = (payload) => {
  return {
    type: "MORE_STORIES",
    payload
  };
};

export const setMakeSecondaryApiCallsTriggered = (makeSecondaryApiCalls, delay, isMobile) => {
  return {
    type: "SET_MAKE_SECONDARY_API_CALLS_TRIGGERED",
    makeSecondaryApiCalls: makeSecondaryApiCalls,
    delay: delay,
    isMobile: isMobile
  };
};

export const setIsLogin = (payload) => {
  return {
    type: ISLOGIN,
    payload
  };
};

export const setUserDetails = (payload) => {
  return {
    type: UPDATE_USER,
    payload
  };
};
export const setCommentsToken = (payload) => {
  return {
    type: UPDATE_COMMENTS_TOKEN,
    payload
  };
};
